import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";
import type PrescriptionJournalEvent from "./prescription-journal-event";

//---- Automatically generated, don't update this part ----

/**
 * Created when we receive a prescription from Apicrypt of which we don't know the type (medication, bio exams...)
 */
export default class GenericPrescriptionUploadedJournalEvent
  extends JournalEvent
  implements PrescriptionJournalEvent
{
  static override type = "generic-prescription-uploaded-journal-event";

  @attr("string") declare source: string;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.generic-prescription-uploaded-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "genericPrescriptionUploadedJournalEvents"
  })
  declare patient: Patient;

  @attr("string") declare uuid: string;

  get startDate(): Date {
    return this.occurredAt;
  }

  get endDate(): undefined {
    return undefined;
  }

  get pdfUrl() {
    return `/api/v1/generic_prescriptions/${this.id}`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "generic-prescription-uploaded-journal-event": GenericPrescriptionUploadedJournalEvent;
  }
}
